import {UnitEconomicsCalculationData} from "../types/unit-economics-calculations.types";

export const defaultUnitEconomicsCalculationData: UnitEconomicsCalculationData = {
  id: 0,
  name: '',
  url: '',
  comment: ''
}
